import type { QueryClient } from '@tanstack/react-query';

/**
 * Drop cached queries after auth/tenant context changes.
 * Reset (not invalidate) so callers do not keep showing the previous user's data.
 */
export async function invalidateAllQueries(queryClient: QueryClient): Promise<void> {
    await queryClient.resetQueries();
}
